import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeGetReceivingProgressDownloadParams } from '~/types/receive.types';

const fetchReceivingProgressDownload = async ({
  ownerCode,
  ...params
}: TypeGetReceivingProgressDownloadParams): Promise<void> => {
  const response = await axiosInstance.get(
    `${API_ENDPOINT.RECEIVE.GET_RECEIVING_PROGRESS_DOWNLOAD}/${ownerCode}/progress/download`,
    {
      params,
      responseType: 'blob',
    }
  );

  downloadBlobDataFile(response);
};

/**
 * [입고관리 > 입고현황] 입고현황 엑셀 다운로드 Mutation Hook
 */
export const useGetReceivingProgressDownloadMutation = () => {
  return useDownloadMutation(fetchReceivingProgressDownload);
};
